var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warper clearfix footLogoBox"},[_vm._v(" 版权所有©2014-"+_vm._s(_vm.currentYear)+" 北京星网锐捷网络技术有限公司 京ICP备13025710号-1 京公网安备11010802020367号 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }